const attendance = {
  // Page meta
  studentAttendance: 'Student Daily Attendance',
  studentAttendanceSubtitle: 'Overview of daily student attendance across all classes',
  teacherAttendanceTitle: 'Class Attendance',
  staffAttendance: 'Staff Attendance',
  staffAttendanceSubtitle: 'Track daily attendance for all teaching and therapy staff',
  // Date navigator
  todayAttendance: "Today's Attendance",
  attendanceRecord: 'Attendance Record',
  previousDay: 'Previous day',
  nextDay: 'Next day',
  // Stats bar
  attendanceRate: 'Attendance Rate',
  bestAttendance: 'Best Attendance',
  needsAttention: 'Needs Attention',
  totalStaff: 'Total Staff',
  present: 'Present',
  absent: 'Absent',
  halfDay: 'Half-Day',
  onLeave: 'On Leave',
  // Table columns
  student: 'Student',
  class: 'Class',
  attendance: 'Attendance',
  remark: 'Remark',
  call: 'Call',
  staff: 'Staff',
  checkIn: 'Check-In',
  checkOut: 'Check-Out',
  status: 'Status',
  // Toggle
  presentLabel: 'Present',
  absentLabel: 'Absent',
  presentClickToAbsent: 'Present — click to mark absent',
  absentClickToPresent: 'Absent — click to mark present',
  tapToToggle: '— tap to toggle',
  noRemark: 'No remark',
  addRemark: 'Add remark...',
  editRemark: 'Edit remark',
  // Bulk actions
  markAllPresent: 'Mark All Present',
  markAllAbsent: 'Mark All Absent',
  markAllPresentTitle: 'Mark All Present?',
  markAllAbsentTitle: 'Mark All Absent?',
  markAllPresentMessage: 'This will mark all {{count}} students as present for today. Are you sure?',
  markAllAbsentMessage: 'This will mark all {{count}} students as absent for today. Are you sure?',
  markAllStaffPresentMessage: 'This will mark all {{count}} staff members as present for today. Are you sure?',
  markAllStaffAbsentMessage: 'This will mark all {{count}} staff members as absent for today. Are you sure?',
  // Notify parents
  notifyParents: 'Notify {{count}} Parent',
  notifyParentsPlural: 'Notify {{count}} Parents',
  absentStudentsToday: '{{count}} student marked absent today',
  absentStudentsTodayPlural: '{{count}} students marked absent today',
  sendAbsenceAlerts: 'Send Absence Alerts?',
  notifyAbsenceMessage: "This will notify parents of {{count}} absent student ({{names}}). Parents will receive an email with today's absence details.",
  notifyAbsenceMessagePlural: "This will notify parents of {{count}} absent students ({{names}}). Parents will receive an email with today's absence details.",
  parentsNotified: 'Parents notified',
  absenceAlertsSent: 'Absence alerts sent for <strong>{{count}} student</strong> — {{names}}{{suffix}}.',
  absenceAlertsSentPlural: 'Absence alerts sent for <strong>{{count}} students</strong> — {{names}}{{suffix}}.',
  andMore: ' and {{count}} more',
  // Footer
  studentsShown: '{{count}} students shown',
  staffShown: '{{count}} staff shown',
  readOnlyHistorical: 'Read-only — historical record',
  toggleToMark: 'Toggle to mark attendance',
  // Empty states
  noAttendanceRecords: 'No attendance records found',
  noStaffAttendanceRecords: 'No staff attendance records found',
  // Staff live indicator
  liveCheckInIndicator: '<strong>{{count}}</strong> staff member checked in today via the dashboard — check-in times are now visible in the table below.',
  liveCheckInIndicatorPlural: '<strong>{{count}}</strong> staff members checked in today via the dashboard — check-in times are now visible in the table below.',
  // Class group header
  presentOf: 'present',
  // Back button
  backToDashboard: 'Back to Dashboard',
  // On Leave status (staff)
  onLeaveLabel: 'On Leave',

  // Action dropdown
  actionsFor: 'Actions for {{name}}',
  actions: 'Actions',
  alert: 'Alert',
  preInspectionTransitLogging: 'Pre-Inspection &amp; Transit Logging',
  preInspectionDescription: 'Mood, physical state, belongings check',
  classroomIncidentEmergency: 'Classroom Incident &amp; Emergency Recording',
  incidentDescription: 'Incident type, severity, actions taken',

  // Pre-Inspection form
  newLog: 'New Log',
  logHistory: 'Log History',
  logAnother: 'Log Another',
  studentMood: 'Student Mood',
  physicalState: 'Physical State',
  belongingsOnPickup: 'Belongings on Pickup',
  additionalNotes: 'Additional Notes',
  notesPlaceholder: 'e.g., Student arrived crying, parent states they did not sleep well...',
  cannedMessages: 'Canned Messages',
  notifyParent: 'Notify Parent / Guardian',
  notifyParentHint: 'Automatically draft and send a summary message',
  sendVia: 'Send via',
  messagePreview: 'Message Preview',
  preInspectionUpdate: 'Pre-Inspection Update',
  dateLabel: 'Date',
  moodLabel: 'Mood',
  notesLabel: 'Notes',
  notRecorded: 'Not recorded',
  savePreInspection: 'Save Pre-Inspection Log',
  preInspectionSaved: 'Pre-Inspection Log Saved!',
  preInspectionSavedHint: 'The pre-inspection record for {{name}} has been saved successfully.',
  todayLogExists: 'A pre-inspection log already exists for this student today. You can still create another one if needed.',
  recordedBy: 'Recorded by',
  noPreInspectionLogs: 'No pre-inspection logs yet',
  noPreInspectionLogsHint: 'Create your first log using the form above',

  // Daywise Pre-Inspection Logs
  preInspectionLogs: 'Pre-Inspection Logs',
  preInspectionLogsForDate: 'Pre-Inspection Logs for {{date}}',
  viewAllPreInspectionLogs: 'View All Pre-Inspection Logs',
  noLogsForDate: 'No pre-inspection logs for this date',
  noLogsForDateHint: 'Logs will appear here once staff record pre-inspections for students',

  // Incident form
  newIncident: 'New Incident',
  incidentHistory: 'Incident History',
  incidentType: 'Incident Type',
  severityLevel: 'Severity Level',
  incidentLocation: 'Location',
  locationLabel: 'Location',
  incidentDescription: 'Description',
  incidentDescriptionPlaceholder: 'Describe what happened in detail...',
  actionsTaken: 'Actions Taken',
  actionsTakenPlaceholder: 'First aid, de-escalation, parent contact...',
  actionsTakenLabel: 'Actions',
  staffInvolved: 'Staff Involved',
  staffInvolvedLabel: 'Staff',
  staffInvolvedPlaceholder: 'e.g., Ms. Emily Watson, Dr. Sarah Mitchell',
  followUpRequiredQuestion: 'Follow-up Required?',
  followUpRequiredHint: 'Flag this incident for follow-up review',
  followUpRequired: 'Follow-up Required',
  followUpNotes: 'Follow-up Notes',
  followUpNotesPlaceholder: 'e.g., Schedule parent meeting, monitor for 3 days...',
  incidentNotifyParentHint: 'Send incident summary to parent/guardian',
  saveIncident: 'Save Incident Report',
  incidentSaved: 'Incident Report Saved!',
  incidentSavedHint: 'The incident report for {{name}} has been recorded successfully.',
  noIncidentLogs: 'No incident reports yet',
  noIncidentLogsHint: 'Create your first incident report using the form above',

  // Daywise incident logs
  incidentLogs: 'Incident Reports',
  incidentLogsForDate: 'Incident Reports for {{date}}',
  viewAllIncidentLogs: 'View All Incident Reports',
  noIncidentsForDate: 'No incident reports for this date',
  noIncidentsForDateHint: 'Reports will appear here once staff record incidents for students',
};

export default attendance;